import React from "react";
import "./Sorry.scss";
import { Link } from "react-router-dom";
import useUTMParams from "../../hooks/utmParams";
const Sorry = () => {
  const utmQuery = useUTMParams();
  return (
    <section className="sorry">
      <div className="container1286">
        <h1>We're Sorry!</h1>
        <h2>unfortunately, we are unable to help you at this time.</h2>
        <p>
          This does not mean that you do not necessarily have a claim. You may
          benefit from approaching a law firm directly. You can search for
          personal injury law firms by searching online for The Law Society
          and/or The Association of Personal Injury Lawyers.
        </p>
        <div className="sorry-btns">
          <Link to={`/${utmQuery}`}>Back To Home</Link>
        </div>
      </div>
    </section>
  );
};

export default Sorry;
